import styled from 'styled-components';

export const Form = styled.form`
  height: calc(100% - 70px);
`;

export const Body = styled.div`
  max-height: calc(60vh);
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  margin-top: 15px;
  padding: 0 20px;
`;

export const Actions = styled.div`
  display: flex;
  justify-content: space-between;
  margin: 20px;
`;
